import React from 'react';
import PropTypes from 'prop-types';
import { Delete, Edit } from '@mui/icons-material';
import { MenuItem, Popover, Tooltip } from '@mui/material';
import { useStyles } from './memberActionPopupStyles';

const popoverProps = {
  anchorOrigin: { vertical: 'bottom', horizontal: 'right' },
  transformOrigin: { vertical: 'top', horizontal: 'right' },
};

const MemberActionPopup = ({ usedHrs, onEditClick, onRemove, ...props }) => {
  const classes = useStyles();
  return (
    <Popover classes={{ paper: classes?.popoverPaper }} {...popoverProps} {...props}>
      <MenuItem onClick={onEditClick} className={classes?.menuItem}>
        <Edit fontSize="small" color="action" /> Edit
      </MenuItem>
      {usedHrs === 0 ? (
        <MenuItem onClick={onRemove} className={classes?.menuItem}>
          <Delete fontSize="small" color="error" /> Remove
        </MenuItem>
      ) : (
        <Tooltip title="User has time record in this project" placement="bottom" arrow>
          <div>
            <MenuItem disabled className={classes?.menuItem}>
              <Delete fontSize="small" color="disabled" />Remove
            </MenuItem>
          </div>
        </Tooltip>
      )}
    </Popover>
  );
};

MemberActionPopup.propTypes = {
  usedHrs: PropTypes.number,
  onEditClick: PropTypes.func,
  onRemove: PropTypes.func,
};

export default MemberActionPopup;
